import { BatchWithClassRoutine } from '@/drizzle/models';
import { BatchViewModel } from '@hidayahlab/academy-suite-corelib';
import BatchNameBadge from './batch-name-badge';
import BatchNumberBadge from './batch-number-badge';

type BatchBadgeProps = {
  batch?: BatchWithClassRoutine | BatchViewModel;
};

export const BatchBadge = ({ batch }: BatchBadgeProps) => {
  if (!batch) {
    return null;
  }

  return (
    <>
      {batch.name ? (
        <BatchNameBadge batchName={batch?.name} />
      ) : (
        <BatchNumberBadge batchNumber={batch?.number} />
      )}
    </>
  );
};
